import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

// Web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBfgxDMc8J9IPtUW1FtIg8wzMYRqsVMflM",
  authDomain: "ai4curb.firebaseapp.com",
  projectId: "ai4curb",
  storageBucket: "ai4curb.appspot.com",
  messagingSenderId: "797599242939",
  appId: "1:797599242939:web:972932a4ce039a1401a79e",
  measurementId: "G-47B7YXTGC5"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);
export default app;